import { useNavigate, useParams } from "react-router-dom";
import restService from "../../../restService";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";
import { useFormik } from "formik";
import { PulseLoader } from "react-spinners";

const EditAgent = () => {
  const [loading, setloading] = useState(true);
  const [msisdn, setMsisdn] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [stations, setStations] = useState([]);
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    retrieveAgentDetails(id);
    fetchStations();
  }, []);

  const fetchStations = async () => {
    const {
      data: { data },
    } = await restService.Management.getStations(campaign.id);

    setStations(data);
  };

  const retrieveAgentDetails = async (id) => {
    setloading(true);

    try {
      const {
        data: { data },
      } = await restService.Management.getAgentById(campaign.id, id);
      setMsisdn(data.msisdn);
      await agentForm.setFieldValue("name", data.name);
      await agentForm.setFieldValue("msisdn", data.msisdn);
      await agentForm.setFieldValue("stationId", data.stationId);

      setloading(false);
    } catch (e) {
      console.log(e);
      setloading(false);
    }
  };

  const onEditStation = async (values) => {
    setIsSaving(true);

    try {
      const editedStation = {
        name: values.name,
        msisdn: values.msisdn,
        stationId: values.stationId,
        campaignId: campaign.id,
      };

      await restService.Management.editAgent(
        user.accessToken,
        campaign.id,
        msisdn,
        editedStation
      );
      navigate(-1);
    } catch (error) {
      console.log(error);
      setIsSaving(false);
    }
  };

  const agentForm = useFormik({
    initialValues: {
      name: "",
      msisdn: "",
      stationId: "",
    },
    onSubmit: onEditStation,
    validationSchema: Yup.object({
      name: Yup.string().required("Agent name required"),
      msisdn: Yup.string()
        .required("Agent phone is required")
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(12, "Phone number must start with 233 & be 12 digits"),
      stationId: Yup.string().required("Select station for agent"),
    }),
  });

  return (
    <div className=" h-full md:mb-8 md:pb-8 px-4 w-full md:px-12">
      <div>
        <div className="flex items-center">
          <button className="mr-6" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
          <h1 className="text-xl">Agents / Edit Agent</h1>
        </div>
      </div>

      <div className=" h-full pb-8   my-8 w-full">
        <div className="bg-white h-full mb-12 ring-1 ring-gray-200 rounded-md shadow-[0_0_10px_-3px_rgba(0,0,0,0.2)] h-full">
          {loading ? (
            <div className="  flex items-center justify-center">
              <PulseLoader color="#FF6A3A" />
            </div>
          ) : (
            <form className="p-8 h-full" onSubmit={agentForm.handleSubmit}>
              <div className="mt-6">
                <div className="flex flex-wrap flex-col gap-6  ">
                  <div className="">
                    <label htmlFor="agentName">
                      <p className="py-1">Agent Name</p>
                      <input
                        placeholder="Enter Agent Name"
                        onChange={agentForm.handleChange}
                        onBlur={agentForm.handleBlur}
                        value={agentForm.values.name}
                        name="name"
                        className="w-full md:w-[35%] border border-gray-300 px-3 pr-8  py-1.5 rounded-md focus:outline-none"
                      />
                      {agentForm.errors.name && agentForm.touched.name && (
                        <p className="mt-1 text-red-400 text-xs">
                          {agentForm.errors.name}
                        </p>
                      )}
                    </label>
                  </div>
                  <div className="">
                    <label htmlFor="AgentName">
                      <p className="py-1">Agent Phone Number</p>
                      <input
                        onChange={agentForm.handleChange}
                        onBlur={agentForm.handleBlur}
                        value={agentForm.values.msisdn}
                        name="msisdn"
                        placeholder="Agent Phone ( 233 XX XXX XXXX )"
                        className="w-full md:w-[35%] border border-gray-300 px-3 pr-8  py-1.5 rounded-md focus:outline-none "
                      />
                      {agentForm.errors.msisdn && agentForm.touched.msisdn && (
                        <p className="mt-1 text-red-400 text-xs">
                          {agentForm.errors.msisdn}
                        </p>
                      )}
                    </label>
                  </div>

                  <div>
                    <label htmlFor="AgentStation">
                      <p className="py-1">Select Agent Station</p>
                      <input
                        list="station-datalist"
                        placeholder="Select Agent Station"
                        name="stationId"
                        value={agentForm.values.stationId}
                        onChange={agentForm.handleChange}
                        onBlur={agentForm.handleBlur}
                        className="w-full md:w-[35%] border border-gray-300 px-3 pr-8  py-1.5 rounded-md focus:outline-none appearance-none"
                      />
                      {agentForm.errors.stationId &&
                        agentForm.touched.stationId && (
                          <p className="mt-1 text-red-400 text-xs">
                            {agentForm.errors.stationId}
                          </p>
                        )}

                      <datalist
                        id="station-datalist"
                        className="appearance-none p-1"
                      >
                        {stations?.map((value, index) => (
                          <option key={index} value={value.stationId}>
                            {value.location}
                          </option>
                        ))}
                      </datalist>
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-12">
                {isSaving ? (
                  <button
                    disabled
                    className="py-2 hover:bg-blue-50 hover:border-blue-500 hover:border-2 hover:text-blue-500 hover:font-bold  px-16 rounded-md text-white bg-blue-500"
                  >
                    Saving...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="flex text-base items-center bg-[#3989DD] border text-white rounded-md py-2 px-16
                         hover:border-[#3989DD] hover:bg-[#4891db] "
                  >
                    Save
                  </button>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAgent;
